//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useContext, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, Form, Card, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Context } from '../../common/context/Context';
import { CandidatePageActions } from "../../candidatePageActions";
import { AddManageGAActions } from "../addManageGAActions";
import { ManageClientsActions } from "../../clients/manageClients/manageClientsActions";
import Select from 'react-select';
import AlertMessage from "../../common/alertMessages/alertMessages";
import ErrorAlertMessage from "../../common/alertMessages/errorAlertMessage";

const BasicForm = ({ editExistingClientCMSData, createAccountCMSData }) => {

    const navigate = useNavigate();

    const context = useContext(Context);
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    dd = String(dd).padStart(2, '0');
    mm = String(mm).padStart(2, '0');

    today = yyyy + '-' + mm + '-' + dd;

    const fetchCreateAccountLabel = (key) => {
        if (createAccountCMSData && createAccountCMSData.Labels) {
            return createAccountCMSData.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }

    const fetchEditExistingLabel = (key) => {
        if (editExistingClientCMSData && editExistingClientCMSData.Labels) {
            return editExistingClientCMSData.Labels.find((el) => el.Key === key)?.Phrase || '';
        }
        return '';
    }

    // let createGACmsData = data && data?.cmsData;

    // const fetchFormLabels = (key) => {
    //     let refCmsContent = createGACmsData && createGACmsData?.Properties;
    //     let label = "";
    //     if (refCmsContent?.Labels) {
    //         refCmsContent?.Labels.map((x) => {
    //             if (x.Key === key) {
    //                 label = x.Phrase;
    //             }
    //         });
    //     }
    //     return label;
    // }
    const cmcProgramClass = ['Looking Inward - Essential', 'Looking Inward - Enhanced', 'Looking Outward']
    let CountryListData = context.countryList;
    const [validated, setValidated] = useState(false);
    const [isDataMissing, setIsDataMissing] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [serviceOfficeList, setServiceOfficeList] = useState([]);
    const [selectedStartDate, setSelectedStartDate] = useState();
    const [selectedServiceOffice, setSelectedServiceOffice] = useState(null)
    const [createGenericAcc, setCreateGenericAcc] = useState({
        ReferenceCode: '',
        StartDate: '',
        EndDate: '',
        NumberOfAccountsAllowed: '',
        ProgramDuration: '',
        Persona: '',
        ProgramClassid: '',
        Country: '',
        ProgramClass: '',
        PersonaId: 0,
        CountryCode: "",
        AccountName: "",
        IsActive: 0,
        RequestedBy: "",
        ProgramName: null,
        serviceOfficeModels: [],
    })
    const [error, setError] = useState({
        genericCode: '',
        noOfAcc: '',
        programDuration: ''
    })
    const [alert, setAlert] = useState({
        message: "",
        type: "",
        showAlert: false
    })
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })

    const handleGenericAccCode = (e) => {

        let tableData = context.viewGATableData && context.viewGATableData;

        let genericCode = e.target.value;
        let errorMessage = '';

        let IsRedundant = tableData && tableData.find((x) => x.referenceCode == genericCode)

        if (IsRedundant !== undefined) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.CodeRedundancyValidation")
        }
        else if (/\s/g.test(genericCode)) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.whiteSpaceError")
        }
        else if (genericCode.length < 5) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.minChar5Error")
        } else if (genericCode.length > 20) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.maxChar20Error")
        }
        setError({
            ...error,
            [e.target.name]: errorMessage
        });
    }

    const handleNoOfAcc = (e) => {

        let noOfAcc = e.target.value;
        let errorMessage = '';
        let numbers = /^[0-9]+$/;
        let decimal = /^[-+]?[0-9]+\.[0-9]+$/;
        if (!(noOfAcc.match(numbers))) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.onlyNumbers")
        } else if (noOfAcc.match(decimal)) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.decimalValidation")
        } else if (noOfAcc < 1) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.minValue1Error")
        } else if (noOfAcc > 999) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.maxValue999Error")
        }
        setError({
            ...error,
            [e.target.name]: errorMessage
        });
    }

    const handleProgramDuration = (e) => {

        let noOfAcc = e.target.value;
        let errorMessage = '';
        let numbers = /^[0-9]+$/;
        let decimal = /^[-+]?[0-9]+\.[0-9]+$/;
        if (!(noOfAcc.match(numbers))) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.onlyNumbers")
        } else if (noOfAcc.match(decimal)) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.decimalValidation")
        } else if (noOfAcc < 1) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.minValue1Error")
        } else if (noOfAcc > 999) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.maxValue999Error")
        }
        setError({
            ...error,
            [e.target.name]: errorMessage
        });
    }

    const createGenericAccount = (e) => {

        let refAlert = JSON.parse(JSON.stringify(alert));

        const form = e.currentTarget;
        if (!form.checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
        }
        setValidated(true);

        const fetchServiceOfficeList = () => {

            const selectedServiceOfficeList = selectedServiceOffice && selectedServiceOffice;
            const serviceOfficeArray = selectedServiceOfficeList.map(x => ({
                RightOfficeId: x.value.rightOfficeId,
                RightOfficeName: x.value.rightOfficeName
            }));
            return serviceOfficeArray;
        }

        let personaName = context.rtPersona && context.rtPersona.length > 0 && context.rtPersona.find((x) => x.rtPersonaId == document.getElementById("rtPersona").value);
        personaName = personaName && personaName.rtPersonaName;

        let CountryName = CountryListData && CountryListData.length > 0 && CountryListData.find((x) => x.standardCodeValue == document.getElementById("country").value);
        CountryName = CountryName && CountryName.title;

        let ProgramClassName = context.rtProgramClass && context.rtProgramClass.length > 0 && context.rtProgramClass.find((x) => x.programclassId == document.getElementById("programClass").value);
        ProgramClassName = ProgramClassName && ProgramClassName.programClass;

        let country = document.getElementById("country").value && document.getElementById("country").value.toUpperCase();

        let refCreateGenericAcc = JSON.parse(JSON.stringify(createGenericAcc));

        refCreateGenericAcc.ReferenceCode = document.getElementById("registrationCode").value;
        refCreateGenericAcc.StartDate = document.getElementById("startDate").value;
        refCreateGenericAcc.EndDate = document.getElementById("endDate").value;
        refCreateGenericAcc.NumberOfAccountsAllowed = parseInt(document.getElementById("accountsCount").value);
        refCreateGenericAcc.ProgramDuration = document.getElementById("programDuration").value;
        refCreateGenericAcc.PersonaId = parseInt(document.getElementById("rtPersona").value);
        refCreateGenericAcc.ProgramClassid = parseInt(document.getElementById("programClass").value);
        refCreateGenericAcc.CountryCode = country && country;
        refCreateGenericAcc.ProgramClass = ProgramClassName;
        refCreateGenericAcc.Country = CountryName;
        refCreateGenericAcc.Persona = personaName;
        refCreateGenericAcc.AccountName = document.getElementById("accountName").value;
        refCreateGenericAcc.IsActive = 1;
        refCreateGenericAcc.RequestedBy = document.getElementById("requestedBy").value;
        refCreateGenericAcc.ProgramName = null;
        refCreateGenericAcc.serviceOfficeModels = fetchServiceOfficeList();

        setCreateGenericAcc(refCreateGenericAcc)

        CandidatePageActions.AddGenericAccount(refCreateGenericAcc).then(
            (res) => {
                if (res.status === 200) {
                    fetchProgramSetupId(document.getElementById("registrationCode").value)
                    refAlert.showAlert = true;
                    refAlert.type = "success";
                    refAlert.message = fetchCreateAccountLabel("GenericAccounts.CreateSuccessLabel");
                } else if (res.status === 500 || res.status === 401) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateAccountLabel("GenericAccounts.CreateErrorLabel");
                } else if (res.status === 400) {
                    setIsDataMissing(true)
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = fetchCreateAccountLabel("GenericAccounts.CreateErrorLabel");
                } else if (res.status === 204) {
                    refAlert.showAlert = true;
                    refAlert.type = "danger";
                    refAlert.message = res ? res : fetchCreateAccountLabel("GenericAccounts.EmptyResponseLabel")
                }
                setAlert(refAlert)
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchProgramSetupId = (refCode) => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        CandidatePageActions.GetGenericAccountByRefCode(refCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    let resData = res.data && res.data;
                    let programSetupId = resData?.programSetupId;
                    let data = uncheckedList && uncheckedList.length > 0 ? uncheckedList : featuresList;
                    saveProgramList(data, programSetupId)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const selectCountry = (e) => {

        let countryCode = e.target.value;
        setSelectedCountry(countryCode)
        getServiceOffice(countryCode);
    }

    const getServiceOffice = async (countryCode) => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        CandidatePageActions.GetServiceOffice(countryCode).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setServiceOfficeList(res.data && res.data)
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchServiceOfficesForMultiSelect = (serviceOffices) => {
        let serviceOfficeOptions = serviceOffices?.map((item) => ({ label: item?.rightOfficeName, value: JSON.parse(JSON.stringify(item)) }))
        return serviceOfficeOptions;
    };

    const handleProgramName = (e) => {

        let name = e.target.value;
        let errorMessage = '';

        let tableData = context.viewGATableData && context.viewGATableData;

        let IsRedundant = tableData && tableData.find((x) => x.accountName == name)

        if (IsRedundant !== undefined) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.NameRedundancyValidation")
        }
        else if (name.length < 3) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.minChar3Error")
        } else if (name.length > 50) {
            errorMessage = fetchCreateAccountLabel("GenericAccounts.maxChar50Error")
        }
        setError({
            ...error,
            [e.target.name]: errorMessage
        });
    }

    const handleProgramClass = () => {

        let programClassId = context.rtProgramClass && context.rtProgramClass.length > 0 && context.rtProgramClass.find((x) => x.programclassId == document.getElementById("programClass").value);
        let countryCode = document.getElementById("country").value;

        fetchProgramList(programClassId.programclassId, countryCode, programClassId.programClass)
        fetchEditExistingClientsJson()
    }

    const [editExistingClientsJson, setEditExistingClientsJson] = useState({});
    const [clickCheckBox, setClickCheckBox] = useState(false)
    const [uncheckedList, setUncheckedList] = useState([]);
    const [checkList, setCheckList] = useState([])
    const [featuresList, setFeaturesList] = useState([])
    const [programList, setProgramList] = useState({
        tools: [],
        assessmentsTasks: [],
        isEventsWebinarsPresent: false,
        isDoceboTilePresent: false,
        eventsWebinars: [],
        doceboTiles: []
    });

    const fetchProgramList = async (programClassId, countryCode, programClass) => {
        let refProgramList = JSON.parse(JSON.stringify(programList));
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        try {
            const res = await AddManageGAActions.GetFeaturesList(programClassId, countryCode);
            if (res.status === 200 || res.status === 204) {
                const resData = res.data || [];
                setFeaturesList(resData);
                setUncheckedList(resData);
                const filterBy = (key, value) => resData.filter((x) => x[key] === value);
                let toolsList = filterBy("itemType", "Tool");
                let assessmentList = filterBy("itemType", "Assessment");
                let eventsList = filterBy("itemName", "EventsPage");
                let doceboList = filterBy("itemName", "DoceboTile");
                let MyCoachPage = filterBy("itemName", "MyCoachPage");
                if (cmcProgramClass.includes(programClass) && MyCoachPage.length > 0) {
                    MyCoachPage = MyCoachPage.map(x => ({ ...x, isActive: false }));
                    const updateCheckList = resData.map(x =>
                        x.itemId === MyCoachPage[0].itemId ? { ...x, isActive: false } : x
                    );
                    setUncheckedList(updateCheckList);
                    setFeaturesList(updateCheckList);
                }
                refProgramList.tools = toolsList;
                refProgramList.assessmentsTasks = assessmentList;
                refProgramList.isEventsWebinarsPresent = eventsList.length > 0;
                refProgramList.isDoceboTilePresent = doceboList.length > 0;
                refProgramList.eventsWebinars = eventsList;
                refProgramList.doceboTiles = doceboList;
                refProgramList.MyCoachPage = MyCoachPage;
                setProgramList(refProgramList);
                setClickCheckBox(false);
            } else {
                handleProgramListError(refErrorMessageAlert);
            }
        } catch (err) {
            console.log(err);
        }
    };
    function handleProgramListError(refErrorMessageAlert) {
        refErrorMessageAlert.showAlert = true;
        setErrorAlert(refErrorMessageAlert);
        window.scrollTo(0, 0);
    }

    const saveProgramList = async (saveList, programSetUpId) => {

        let payload = saveList && saveList;
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await ManageClientsActions.SaveProgramSetupList(programSetUpId, payload).then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    navigate("/generic-accounts-details", { state: { addRefCode: document.getElementById("registrationCode").value } })
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const fetchEditExistingClientsJson = async () => {

        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

        await ManageClientsActions.GetEditExistingClientsJSON().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setEditExistingClientsJson(res.data && res.data);
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    const unselectCheckBox = (e, item) => {

        setClickCheckBox(true)

        let listFromRes = featuresList && featuresList.length > 0 && featuresList;
        let updatedArray = listFromRes && listFromRes.map(x => x.itemDetailsId == item.itemDetailsId
            ? { ...x, isActive: !(x.isActive) }
            : x
        )
        setUncheckedList(updatedArray && updatedArray);
        setFeaturesList(updatedArray && updatedArray)
        let checkedArray = updatedArray && updatedArray.filter((x) => x.isActive == true);
        checkedArray = checkedArray && checkedArray.map((x) => x.itemDetailsId);
        setCheckList(checkedArray && checkedArray);
    }


    const handleUserServiceOfficeChange = (value) => {
        setSelectedServiceOffice(value);
    }

    const showModal = () => {
        let refAlert = JSON.parse(JSON.stringify(alert));
        refAlert.showAlert = false;
        setAlert(refAlert)
    }

    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    return (
        <>
            <h1 className="h3 mb-3">{fetchCreateAccountLabel("GenericAccounts.CreateAccountLabel")}</h1>
            <Card>
                <Card.Body>
                    {errorAlert?.showAlert &&
                        <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
                    }
                    <Form noValidate validated={validated}>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.GenericAccountsHeader")}</Form.Label>
                            <Form.Control
                                className="program-name"
                                id="accountName"
                                name="programName"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.GenericAccountsHeader")}
                                onChange={(e) => handleProgramName(e)}
                                isInvalid={!!error.programName}
                                required
                            />
                            <Form.Control.Feedback type='invalid'>
                                {error.programName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.GenericRegistrationCode")}</Form.Label>
                            <Form.Control
                                name="genericCode"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.GenericRegistrationCode")}
                                type="text"
                                id="registrationCode"
                                required
                                minLength="3"
                                maxLength="50"
                                onChange={(e) => handleGenericAccCode(e)}
                                isInvalid={!!error.genericCode}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {error.genericCode}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.StartDate")}</Form.Label>
                            <Form.Control
                                type="date"
                                name="startDate"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.StartDate")}
                                id="startDate"
                                required
                                min={today}
                                onChange={(e) => setSelectedStartDate(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.ExpirationDate")}</Form.Label>
                            <Form.Control
                                type="date"
                                name="expirationDate"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.ExpirationDate")}
                                id="endDate"
                                required
                                min={selectedStartDate && selectedStartDate}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.NumberOfAccounts")}</Form.Label>
                            <Form.Control
                                type="tel"
                                name="noOfAcc"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.NumberOfAccounts")}
                                id="accountsCount"
                                required
                                isInvalid={!!error.noOfAcc}
                                onChange={(e) => handleNoOfAcc(e)}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {error.noOfAcc}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.ProgramDurationInDays")}</Form.Label>
                            <Form.Control
                                type="tel"
                                name="programDuration"
                                placeholder={fetchCreateAccountLabel("GenericAccounts.ProgramDurationInDays")}
                                id="programDuration"
                                required
                                isInvalid={!!error.programDuration}
                                onChange={(e) => handleProgramDuration(e)}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {error.programDuration}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.RTPersona")}</Form.Label>
                            <Form.Select
                                aria-label="RT Persona Select"
                                id="rtPersona"
                                name="rtPersona"
                            >
                                <option>{fetchCreateAccountLabel("GenericAccounts.personaOption")}</option>
                                {context.rtPersona && context.rtPersona.length > 0 && context.rtPersona.map((item) => (
                                    <option id={item?.rtPersonaName} value={item?.rtPersonaId}>{item?.rtPersonaName}</option>
                                ))}
                            </Form.Select>
                            <div className="invalid-feedback">{fetchCreateAccountLabel("GenericAccounts.personaValidation")}</div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.Country")}</Form.Label>
                            <Form.Select
                                aria-label="country"
                                id="country"
                                name="country"
                                onChange={(e) => selectCountry(e)}
                            >
                                <option>{fetchCreateAccountLabel("GenericAccounts.countryOption")}</option>
                                {CountryListData && CountryListData.map((item) => (
                                    <option value={item?.standardCodeValue}>{item?.title}</option>
                                ))}
                            </Form.Select>
                            <div className="invalid-feedback">{fetchCreateAccountLabel("GenericAccounts.countryValidation")}</div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.ProgramClassAssigned")}</Form.Label>
                            <Form.Select
                                aria-label="Program Class Select"
                                id="programClass"
                                name="programClass"
                                onChange={(e) => handleProgramClass(e)}
                            >
                                <option>{fetchCreateAccountLabel("GenericAccounts.programClassOption")}</option>
                                {context.rtProgramClass && context.rtProgramClass.length > 0 && context.rtProgramClass.map((item) => (
                                    <option value={item?.programclassId}>{item?.programClass}</option>
                                ))}
                            </Form.Select>
                            <div className="invalid-feedback">{fetchCreateAccountLabel("GenericAccounts.programClassValidation")}</div>
                        </Form.Group>
                        {document.getElementById("programClass") && document.getElementById("programClass").value &&
                            <div>
                                <Card mt-3>
                                    <Card.Title className="mb-0 mt-4">{fetchEditExistingLabel("EditExistingClient.Features")}</Card.Title>
                                    {programList.tools && programList.tools.length > 0 &&
                                        <div>
                                            <Card.Header>
                                                <Card.Title className="mb-0 mt-4">{fetchEditExistingLabel("EditExistingClient.Tools")}</Card.Title>
                                            </Card.Header>

                                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 30px" }}>
                                                <Row>
                                                    {programList.tools.map((item) =>
                                                        <Col md='4' xs='12'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Check
                                                                    style={{ marginRight: "15px" }}
                                                                    label={item?.itemName}
                                                                    type="checkbox"
                                                                    checked={clickCheckBox
                                                                        ? (checkList && checkList.includes(item?.itemDetailsId)) ? true : false
                                                                        : item?.isActive}
                                                                    onClick={(e) => unselectCheckBox(e, item)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )
                                                    }
                                                </Row>
                                            </Card.Body>
                                        </div>
                                    }
                                    {programList.assessmentsTasks && programList.assessmentsTasks.length > 0 &&
                                        <div>
                                            <Card.Header>
                                                <Card.Title className="mb-0 mt-4">{fetchEditExistingLabel("EditExistingClient.AssessmentsTasks")}</Card.Title>
                                            </Card.Header>

                                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 30px" }}>
                                                <Row>
                                                    {programList.assessmentsTasks.map((item) =>
                                                        <Col md='4' xs='12'>
                                                            <Form.Group className="mb-3">
                                                                <Form.Check
                                                                    style={{ marginRight: "15px" }}
                                                                    label={item?.itemName}
                                                                    type="checkbox"
                                                                    checked={clickCheckBox
                                                                        ? (checkList && checkList.includes(item?.itemDetailsId)) ? true : false
                                                                        : item?.isActive}
                                                                    onClick={(e) => unselectCheckBox(e, item)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )
                                                    }
                                                </Row>
                                            </Card.Body>
                                        </div>
                                    }
                                    {(programList?.isEventsWebinarsPresent || programList?.isDoceboTilePresent) &&
                                        <div>
                                            <Card.Header>
                                                <Card.Title className="mb-0 mt-4"> {fetchEditExistingLabel("EditExistingClient.EventsWebinars")}</Card.Title>
                                            </Card.Header>
                                            <Card.Body className="text-left" style={{ padding: "0 30px" }}>
                                                <div>
                                                    {programList && programList?.isEventsWebinarsPresent &&
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                style={{ marginRight: "15px" }}
                                                                label={fetchEditExistingLabel("EditExistingClient.AllEventsWebinars")}
                                                                type="checkbox"
                                                                checked={
                                                                    clickCheckBox
                                                                        ? !!checkList?.includes(programList?.eventsWebinars?.[0]?.itemDetailsId)
                                                                        : !!programList?.eventsWebinars?.[0]?.isActive
                                                                }
                                                                onClick={(e) => unselectCheckBox(e, programList?.eventsWebinars[0])}
                                                            />
                                                        </Form.Group>
                                                    }
                                                    {programList && programList?.isDoceboTilePresent &&
                                                        <Form.Group className="mb-3">
                                                            <Form.Check
                                                                style={{ marginRight: "15px" }}
                                                                label={fetchEditExistingLabel("EditExistingClient.ClientEventsWebinars")}
                                                                type="checkbox"
                                                                checked={
                                                                    clickCheckBox
                                                                        ? !!checkList?.includes(programList?.doceboTiles?.[0]?.itemDetailsId)
                                                                        : !!programList?.doceboTiles?.[0]?.isActive
                                                                }
                                                                onClick={(e) => unselectCheckBox(e, programList?.doceboTiles[0])}
                                                            />
                                                        </Form.Group>
                                                    }
                                                </div>
                                            </Card.Body>
                                        </div>
                                    }
                                    {programList && programList?.MyCoachPage && programList?.MyCoachPage.length > 0 &&
                                        <div>
                                            <Card.Header>
                                                <Card.Title className="mb-0 mt-4">{fetchEditExistingLabel("EditExistingClient.CoachMeeting")}</Card.Title>
                                            </Card.Header>

                                            <Card.Body className="text-left" style={{ display: "flex", flexWrap: "wrap", padding: "0 30px" }}>
                                                <Row>
                                                    <Form.Group className="mb-3">
                                                        <Form.Check
                                                            style={{ marginRight: "15px" }}
                                                            label={fetchEditExistingLabel("EditExistingClient.EnableMyCoachpage")}
                                                            type="checkbox"
                                                            aria-label="Checkbox"
                                                            disabled={!context.permissionsList?.includes("Clients.editclientprogramsetup")}
                                                            checked={
                                                                clickCheckBox
                                                                    ? !!checkList?.includes(programList?.MyCoachPage?.[0]?.itemDetailsId)
                                                                    : !!programList?.MyCoachPage?.[0]?.isActive
                                                            }
                                                            onClick={(e) => unselectCheckBox(e, programList?.MyCoachPage[0])} />
                                                    </Form.Group>
                                                </Row>
                                            </Card.Body>
                                        </div>
                                    }
                                </Card>
                            </div>
                        }
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.ServiceOffice")}</Form.Label>
                            <Select
                                name="country"
                                options={serviceOfficeList && fetchServiceOfficesForMultiSelect(serviceOfficeList)}
                                isMulti
                                isDisabled={selectedCountry == ""}
                                value={selectedServiceOffice}
                                aria-label="Role Office Select"
                                onChange={selected => {
                                    handleUserServiceOfficeChange(selected);
                                }}
                            />
                            <div className="invalid-feedback">{fetchCreateAccountLabel("GenericAccounts.serviceOfficeValidation")}</div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>{fetchCreateAccountLabel("GenericAccounts.RequestedBy")}</Form.Label>
                            <Form.Select
                                aria-label="Requested By Select"
                                id="requestedBy"
                                name="requestedBy"
                            >
                                <option>{fetchCreateAccountLabel("GenericAccounts.select")}</option>
                                {context.usersEmailList && context.usersEmailList.length > 0 && context.usersEmailList.map((item) => (
                                    <option id={item} value={item}>{item}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        {alert?.showAlert &&
                            <AlertMessage alertMessage={alert?.message} alertType={alert?.type} showAlert={showModal} />
                        }
                        <Button
                            variant="primary"
                            onClick={(e) => createGenericAccount(e)}
                        >
                            {fetchCreateAccountLabel("GenericAccounts.Create")}
                        </Button>
                        {isDataMissing &&
                            <Alert variant={"dandger"}>
                                <div className="alert-message">
                                    <strong>{fetchCreateAccountLabel("GenericAccounts.FillAllFields")}</strong>
                                </div>
                            </Alert>
                        }
                    </Form>
                </Card.Body>
            </Card>
        </>
    )
};

const AddManageGA = () => {

    const [createGAJson, setCreateGAJson] = useState({});
    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    });
    const [adminCreateAccountCMSData, setAdminCreateAccountCMSData] = useState({ title: "", description: "", tabNavigationTitle: "", pageContent: {} });

    // const fetchCreateGAJson = async () => {

    //     let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    //     await AddManageGAActions.CreateGAJSON().then(
    //         (res) => {
    //             if (res.status === 200 || res.status === 204) {
    //                 setCreateGAJson(res.data && res.data);
    //             }
    //             else {
    //                 refErrorMessageAlert.showAlert = true;
    //                 setErrorAlert(refErrorMessageAlert);
    //                 window.scrollTo(0, 0);
    //             }
    //         },
    //         (err) => {
    //             console.log(err);
    //         }
    //     );
    // }
    const getAdminCreateAccountCMSContent = async () => {
        const payload = { pagename: 'Candidates' }
        try {
            await CandidatePageActions.getAdminCandidateCMSContent(payload).then((res) => {
                if (res.status == 200 || res.status == 204) {
                    const data = res.data;
                    data.Pages.forEach((el) => {
                        if (el.Key === 'Candidates.CandidatesSearch') {
                            const { Title, Description, TabNavigationTitle, Components } = el;
                            setAdminCreateAccountCMSData({ title: Title, description: Description, tabNavigationTitle: TabNavigationTitle, pageContent: Components });
                        }
                    });
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        getAdminCreateAccountCMSContent();
        //fetchCreateGAJson()
    }, [])

    return (
        <React.Fragment>
            <Helmet title="Cards" />
            <Container fluid className="p-0 mt-3">
                <Row>
                    <Col lg="12">
                        <BasicForm
                            editExistingClientCMSData={adminCreateAccountCMSData?.pageContent["Edit-Existing-Client"]}
                            createAccountCMSData={adminCreateAccountCMSData?.pageContent["GenericAccounts.CreateAccountLabel"]}
                        />
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
};

export default AddManageGA;
